module.exports = __webpack_public_path__ + "img/table-food-preference.0d556fa5.svg";